import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import Verify from './pages/Verify';
import { Box } from '@mui/material';

// Layout component for pages with header and footer
const MainLayout = ({ children }) => (
  <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <Header />
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      {children}
    </Box>
    <Footer />
  </Box>
);

// Layout component for Verify page without header and footer
const VerifyLayout = ({ children }) => (
  <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    {children}
  </Box>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/verify/:brandname" element={
          <VerifyLayout>
            <Verify />
          </VerifyLayout>
        } />
        <Route path="*" element={
          <MainLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;